export default __webpack_public_path__ + "static/bg-17b16f46a1d8a8ef19ed79e482ec6bdc.png";